import * as React from 'react'

import { styled } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'
import AppBar from '@mui/material/AppBar'

import Logo from 'components/atomic/atoms/logo'

const StyledAppBar = styled(AppBar)`
    box-shadow: none;
    background: ${({ theme }) => theme.palette.background.default};
    border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`

interface HeaderOnlyLogoProps {
    clickableLogo?: boolean
}

const HeaderOnlyLogo = ({ clickableLogo = true }: HeaderOnlyLogoProps) => {
    return (
        <StyledAppBar>
            <Toolbar sx={{ m: 'auto' }}>
                <Logo clickable={clickableLogo} />
            </Toolbar>
        </StyledAppBar>
    )
}

export default HeaderOnlyLogo
